class DropdownMenu extends HTMLElement {
  constructor() {
    super();

    this.classes = {
      hover: 'is-hover',
      active: 'is-active',
      animate: 'show-from-bottom',
    };
    this.selectors = {
      header: '.shopify-section-header',
      background: '.header-background',
      topMenuItem: '.header__menu-item--top',
      menus: 'dropdown-menu, mega-menu',
      wrapper: '.list-menu',
      childAnimate: '.list-menu-dropdown > .list-menu',
      button: 'button'
    };
    this.timeout;

    this.setupEventListeners();
  }

  connectedCallback() {
    this.setupEventListeners();
  }

  setupEventListeners() {
    const button = this.querySelector(this.selectors.button);

    if (button && !button.hasAttribute('data-listeners-added')) {
      button.setAttribute('data-listeners-added', 'true');
      
      button.addEventListener('click', (event) => {
        event.preventDefault();
        this.handleClick();
      });
      
      button.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          event.stopPropagation();
          this.handleClick();
        } else {
          this.handleEscape(event);
        }
      });
    }

    if (!this.hasAttribute('data-container-listeners-added')) {
      this.setAttribute('data-container-listeners-added', 'true');
      this.addEventListener('click', (event) => {
        if (!event.defaultPrevented && event.target !== button) {
          this.handleClick();
        }
      });
    }

    if (!this.hasAttribute('data-mouse-listeners-added')) {
      this.setAttribute('data-mouse-listeners-added', 'true');
      this.addEventListener('mouseenter', this.handleMouseover.bind(this));
      this.addEventListener('mouseleave', this.handleMouseleave.bind(this));
    }
  }

  handleMouseover() {
    if (this.classList.contains(this.classes.active)) return;

    this.bindEvent();
    this.removeClasses();
    this.addClasses();         
    this.resetBackground();
    //this.animateMenu();
  }

  handleClick() {
    const button = this.querySelector(this.selectors.button);
    const listItems = document.querySelectorAll('.is-megamenu');
    const listArray = [...listItems];

    listArray.forEach((item) => {
      if (item == this) return;
      item.classList.remove(this.classes.active);
      item.setAttribute('aria-expanded', false);

      const itemButton = item.querySelector('button');
      if (itemButton) {
        itemButton.setAttribute('aria-expanded', false);
      }
    });

    if (this.classList.contains(this.classes.active)) {
      this.classList.remove(this.classes.active);
      this.setAttribute('aria-expanded', false);
      if (button) button.setAttribute('aria-expanded', false);
    } else {
      this.classList.add(this.classes.active);
      this.setAttribute('aria-expanded', true);
      if (button) button.setAttribute('aria-expanded', true);
    }
  }

  handleEscape(event) {
    const childAnimate = this.querySelector(this.selectors.childAnimate);
    if (childAnimate) {
      setTimeout(() => {
        childAnimate.classList.add(this.classes.animate);
      }, 150);
    }

    if (event.key == 'Escape') {
      this.classList.remove(this.classes.active);
      this.setAttribute('aria-expanded', false);
    }

    const focusableItems = this.querySelectorAll('.list-menu-dropdown a');
    const firstElement = focusableItems[0];
    const lastItem = focusableItems[focusableItems.length - 1];

    if (event.key == 'Tab' && event.target == lastItem && !event.shiftKey) {
      this.classList.remove(this.classes.active);
      this.setAttribute('aria-expanded', false);
    }
    if (event.key === 'Tab' && event.target === firstElement && event.shiftKey) {
      this.classList.remove(this.classes.active);
      this.setAttribute('aria-expanded', false);
    }
  }

  handleMouseleave() {
    if (!this.header) return;

    this.reset();
    this.resetBackground();

    this.header.classList.remove(this.classes.hover);
    this.wrapper.removeEventListener('mouseleave', this.onHeaderMouseLeaveEvent);
  }

  bindEvent() {
    this.onHeaderMouseLeaveEvent = this.onHeaderMouseLeaveEvent || this.handleMouseleave.bind(this);
    this.header = this.header || document.querySelector(this.selectors.header);

    this.wrapper = this.closest(this.selectors.wrapper);
    this.wrapper.addEventListener('mouseleave', this.onHeaderMouseLeaveEvent);
  }

  addClasses() {
    const isTopLevel = this.querySelector(this.selectors.topMenuItem);

    this.classList.add(this.classes.active);
    this.setAttribute('aria-expanded', true);

    if (!this.header) {
      this.header = document.querySelector(this.selectors.header);
    }
    if (this.header) {
      this.header.classList.add(this.classes.hover);
    }
  }

  removeClasses() {
    const menus = this.header.querySelectorAll(this.selectors.menus);

    menus.forEach((menu) => {
      let found = false;
      const childMenus = menu.querySelectorAll('dropdown-menu');
      childMenus.forEach((element) => {
        if (element === this) {
          found = true;
          return;
        }
      });

      if (!found) menu.reset();
    });
  }

  isHover() {
    return this.header.classList.contains(this.classes.hover);
  }

  reset() {
    this.classList.remove(this.classes.active);

    const childAnimate = this.querySelector(this.selectors.childAnimate);
    if (childAnimate) childAnimate.classList.remove(this.classes.animate);

    clearTimeout(this.timeout);
  }

  resetBackground() {
    const background = this.header.querySelector(this.selectors.background);
    background.classList.remove(this.classes.active);
  }

  animateMenu() {
    const childAnimate = this.querySelector(this.selectors.childAnimate);
    if (childAnimate) {
      setTimeout(() => {
        childAnimate.classList.add(this.classes.animate);
      }, 150);
    }
  }

  close() {
    this.handleMouseleave();
  }
}
customElements.define('dropdown-menu', DropdownMenu);


/*

class MegaMenu extends HTMLElement {
  constructor() {
    super();

    this.classes = {
      hover: 'is-hover',
      active: 'is-active',
      animate: 'show-from-bottom',
    };
    this.selectors = {
      header: '.shopify-section-header',
      background: '.header-background',
      dropdown: '.list-menu-dropdown',
      menus: 'dropdown-menu, mega-menu',
      wrapper: '.list-menu',
      childAnimate: '.mega-menu__item, .mega-menu__promo'
    };
    this.timeout = [];

    //this.addEventListener('focusin', this.handleMouseover.bind(this));
    this.addEventListener('mouseenter', this.handleMouseover.bind(this));
  }

  handleMouseover() {
    if (this.classList.contains(this.classes.active)) return;
    
    this.bindEvent();
    this.removeClasses();
    this.addClasses();
    this.showSublist();
  }

  handleMouseleave() {
    if (!this.header) return;

    this.reset();
    this.resetBackground();

    this.header.classList.remove(this.classes.hover);
    this.wrapper.removeEventListener('mouseleave', this.onHeaderMouseLeaveEvent);
  }

  handleTouchMoveOutside(ev) {
    if (!this.header) return;
    
    let target_section = ev.targetTouches[0].target.closest(this.selectors.header);
    if(!target_section || this.header.classList.contains('shopify-section-header-hidden')) {
      this.reset();
      this.resetBackground();
      
      this.header.classList.remove(this.classes.hover);
      document.removeEventListener('touchmove', this.onHeaderTouchMoveOutsideEvent);
    }
  }

  bindEvent() {
    this.onHeaderMouseLeaveEvent = this.onHeaderMouseLeaveEvent || this.handleMouseleave.bind(this);
    this.onHeaderTouchMoveOutsideEvent = this.onHeaderTouchMoveOutsideEvent || this.handleTouchMoveOutside.bind(this);
    
    this.header = this.header || document.querySelector(this.selectors.header);

    this.wrapper = this.closest(this.selectors.wrapper)
    this.wrapper.addEventListener('mouseleave', this.onHeaderMouseLeaveEvent);
    document.addEventListener('touchmove', this.onHeaderTouchMoveOutsideEvent);
  }

  showSublist() {
    const dropdown = this.querySelector(this.selectors.dropdown);
    const background = this.header.querySelector(this.selectors.background);
    background.style.setProperty('--height', this.header.clientHeight + dropdown.clientHeight + 'px');
    background.classList.add(this.classes.active);
  }

  addClasses() {
    this.classList.add(this.classes.active);

    const childAnimate = this.querySelectorAll(this.selectors.childAnimate);
    const delay = childAnimate.length > 5 ? 75 : 150;
    childAnimate.forEach((element, index) => {
      const timeout = setTimeout(() => {
        element.classList.add(this.classes.animate);
      }, (delay * index) + 100);
      
      this.timeout.push(timeout);
    });
    
    this.header.classList.add(this.classes.hover);
  }

  removeClasses() {
    const menus = this.header.querySelectorAll(this.selectors.menus);
    menus.forEach((menu) => {
      menu.reset();
    });
  }

  reset() {
    this.classList.remove(this.classes.active);

    const childAnimate = this.querySelectorAll(this.selectors.childAnimate);
    childAnimate.forEach((element) => {
      element.classList.remove(this.classes.animate);
    });
    this.timeout.forEach((timeout) => {
      clearTimeout(timeout);
    });
  }

  resetBackground() {
    const background = this.header.querySelector(this.selectors.background);
    background.classList.remove(this.classes.active);
  }

  close() {
    this.handleMouseleave();
  }
}
customElements.define('mega-menu', MegaMenu);
*/

class MegaMenu extends HTMLElement {
  constructor() {
    super();

    this.classes = {
      hover: 'is-hover',
      active: 'is-active',
      animate: 'show-from-bottom',
    };
    this.selectors = {
      header: '.shopify-section-header',
      background: '.header-background',
      dropdown: '.list-menu-dropdown',
      menus: 'dropdown-menu, mega-menu',
      wrapper: '.list-menu',
      childAnimate: '.mega-menu__item, .mega-menu__promo',
      topMenuItem: '.header__menu-item--top',
      button: 'button'
    };
    this.timeout = [];

    // Wait for the button to be available
    this.setupEventListeners();
  }

  connectedCallback() {
    // Ensure event listeners are set up when element is connected to DOM
    this.setupEventListeners();
  }

  setupEventListeners() {
    const button = this.querySelector(this.selectors.button);
    if (button && !button.hasAttribute('data-listeners-added')) {
      // Mark button to prevent duplicate listeners
      button.setAttribute('data-listeners-added', 'true');
      
      // Attach events directly to the button for better screen reader support
      button.addEventListener('click', (event) => {
        event.preventDefault();
        this.handleClick();
      });
      
      button.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          event.stopPropagation();
          this.handleClick();
        } else if (event.key === 'Escape') {
          this.handleEscape(event);
        }
      });
    }

    // Keep mouse events on the container
    if (!this.hasAttribute('data-mouse-listeners-added')) {
      this.setAttribute('data-mouse-listeners-added', 'true');
      this.addEventListener('mouseenter', this.handleMouseover.bind(this));
      this.addEventListener('mouseleave', this.handleMouseleave.bind(this));
    }
  }

  handleClick() {
    const button = this.querySelector(this.selectors.button);
    const listItems = document.querySelectorAll('.is-megamenu');
    const listArray = [...listItems];
    listArray.forEach((item) => {
      if(item == this) return;
      item.classList.remove(this.classes.active);
      item.setAttribute('aria-expanded', false);
      // Also update the button's aria-expanded
      const itemButton = item.querySelector('button');
      if (itemButton) {
        itemButton.setAttribute('aria-expanded', false);
      }
    });

    if (this.classList.contains(this.classes.active)) {
      this.classList.remove(this.classes.active)
      this.setAttribute('aria-expanded', false);
      if (button) {
        button.setAttribute('aria-expanded', false);
      }
    } else {
      this.classList.add(this.classes.active);
      this.setAttribute('aria-expanded', true);
      if (button) {
        button.setAttribute('aria-expanded', true);
      }
    }
  }

  handleEscape(event) {
    if (event.key == 'Escape') {
      this.classList.remove(this.classes.active);
      this.setAttribute('aria-expanded', false);
    }

    const focusableItems = this.querySelectorAll('.list-menu-dropdown a');
    if (focusableItems.length) {
      const firstElement = focusableItems[0];
      const lastItem = focusableItems[focusableItems.length - 1];
  
      if(event.key == 'Tab' && event.target == lastItem && !event.shiftKey) {
        this.classList.remove(this.classes.active);
        this.setAttribute('aria-expanded', false);
      }
      if (event.key === 'Tab' && event.target === firstElement && event.shiftKey) {
        this.classList.remove(this.classes.active);
        this.setAttribute('aria-expanded', false);
      }
    }
  }

  handleMouseover() {
    this.classList.add(this.classes.active);
    this.setAttribute('aria-expanded', true);
  }
  handleMouseleave() {
    this.classList.remove(this.classes.active);
    this.setAttribute('aria-expanded', false);
  }
  
  bindEvent() {
    this.onHeaderMouseLeaveEvent = this.onHeaderMouseLeaveEvent || this.handleMouseleave.bind(this);
    
    this.header = this.header || document.querySelector(this.selectors.header);

    this.wrapper = this.closest(this.selectors.wrapper)
    this.wrapper.addEventListener('mouseleave', this.onHeaderMouseLeaveEvent);
  }

  showSublist() {
    const dropdown = this.querySelector(this.selectors.dropdown);
    const background = this.header.querySelector(this.selectors.background);
    background.style.setProperty('--height', this.header.clientHeight + dropdown.clientHeight + 'px');
    background.classList.add(this.classes.active);
  }

  addClasses() {
    this.classList.add(this.classes.active);

    const childAnimate = this.querySelectorAll(this.selectors.childAnimate);
    const delay = childAnimate.length > 5 ? 75 : 150;
    childAnimate.forEach((element, index) => {
      const timeout = setTimeout(() => {
        element.classList.add(this.classes.animate);
      }, (delay * index) + 100);
      
      this.timeout.push(timeout);
    });
    
    this.header.classList.add(this.classes.hover);
  }

  removeClasses() {
    const menus = this.header.querySelectorAll(this.selectors.menus);
    menus.forEach((menu) => {
      menu.reset();
    });
  }

  reset() {
    this.classList.remove(this.classes.active);

    const childAnimate = this.querySelectorAll(this.selectors.childAnimate);
    childAnimate.forEach((element) => {
      element.classList.remove(this.classes.animate);
    });
    this.timeout.forEach((timeout) => {
      clearTimeout(timeout);
    });
  }

  resetBackground() {
    const background = this.header.querySelector(this.selectors.background);
    background.classList.remove(this.classes.active);
  }

  close() {
    this.handleMouseleave();
  }
}
customElements.define('mega-menu', MegaMenu);

/*function pressEscape(e) {
  if(e.key == 'Escape') {
    const listItems = document.querySelectorAll('.is-megamenu');
    const listArray = [...listItems];
    listArray.forEach((item) => {
      item.classList.remove('is-active');
    });
  }
}

window.addEventListener('keydown', pressEscape);*/